import React from "react";

export default function TowersFlames() {
  return (
    <>
      <h3>Tower's Flame is a song about the Malkier fighting the Shadow's horde to buy their people time to flee to safety. Knowing that they themselves would die.</h3>
      <p class="c2">
        <span>
        <p>The Blight rolled down, its darkness wide,</p>
        <p>A shadow's tide, a nation’s grief.</p>
        <p>Yet still we stood, no place to hide,</p>
        <p>Our blades drawn sharp, though hope was brief.</p>
        </span>
      </p>
      <p class="c2">
        <span>
        <p>The sky turned red, the towers burned,</p>
        <p>But hearts of steel would not be turned.</p>
        </span>
      </p>
      <p class="c2">
        <span>
        <p>We stood, we fought, though doom was near,</p>
        <p>For Malkier, for all we hold dear.</p>
        <p>Through blood and fire, through endless strife,</p>
        <p>We gave them time, we gave them life.</p>
                </span>
      </p>
      <p class="c2">
        <span>
        <p>Through ash and screams, the towers fell,</p>
        <p>A golden crane in shadows drowned.</p>
        <p>Yet still we charged through night’s cold spell,</p>
        <p>Each step, each breath—our battle ground.</p>
        </span>
      </p>
      <p class="c2">
        <span>
        <p>With every cry, with every blow,</p>
        <p>We bought their chance to safely go.</p>
        </span>
      </p>
      <p class="c2">
        <span>
        <p>We stood, we fought, though doom was near,</p>
        <p>For Malkier, for all we hold dear.</p>
        <p>Through blood and fire, through endless strife,</p>
        <p>We gave them time, we gave them life.</p>
        </span>
      </p>
      <p class="c2">
        <span>
        <p>The shadow pressed, the lines grew thin,</p>
        <p>But we stood strong, though none could win.</p>
        <p>For children’s laughs, for loved ones’ names,</p>
        <p>We lit the dark with Malkier’s flames.</p>
        </span>
      </p>
      <p class="c2">
        <span>
        <p>O Malkier’s pride, O Malkier’s pain,</p>
        <p>The shadow claimed our land, our name.</p>
        <p>In hearts of those who didn't die,</p>
        <p>The Golden Crane will always fly.</p>
        </span>
      </p>

    </>
  );
}
